var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.module.loading || _vm.data.loading)?_c('Loader'):[_c('h1',[_vm._v(_vm._s(_vm.module.label))]),_c('h3',[_vm._v("New Item")]),_c('ModuleItemForm',{attrs:{"form-elements":_vm.module.fields},on:{"submit":_vm.newModuleItem}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }